__webpack_require__.p = "https://aluma.sk/public/";